import { Line } from "./CommonLine.style";

const CommonLine = () => {
  return (
    <Line/>
  );
};

export default CommonLine;